// extracted by mini-css-extract-plugin
export default {"wrapper":"switcher-feature_wrapper__r60Sd"};